var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile_menu_icon",
    transform: "translate(-3596 -1116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5118",
    "data-name": "Rectangle 5118",
    transform: "translate(3596 1116)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24001",
    "data-name": "Group 24001",
    transform: "translate(-417 -2120.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M18.759,15H16.241A8.764,8.764,0,0,0,7.5,23.823a2.941,2.941,0,0,0,2.941,2.941H24.558A2.965,2.965,0,0,0,27.5,23.741,8.741,8.741,0,0,0,18.759,15Zm5.8,10.588H10.441a1.776,1.776,0,0,1-1.765-1.847,7.564,7.564,0,0,1,7.564-7.564h2.518a7.588,7.588,0,0,1,7.564,7.647A1.765,1.765,0,0,1,24.558,25.588Z",
    transform: "translate(4007.5 3232.271)",
    fill: "#39f8ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M17.082,16.165A4.582,4.582,0,1,0,12.5,11.582a4.582,4.582,0,0,0,4.582,4.582Zm0-7.856a3.273,3.273,0,1,1-3.273,3.273,3.273,3.273,0,0,1,3.273-3.273Z",
    transform: "translate(4007.917 3230.035)",
    fill: "#39f8ba"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMenuIcon);
export default __webpack_public_path__ + "static/media/profile_menu_icon.5dac2143e7bbec8ba3802f5f73bef296.svg";
export { ForwardRef as ReactComponent };